import { Swiper } from 'swiper';
import { Autoplay } from 'swiper/modules';

export default function main() {
    const $sliderContainerOne = document.querySelector<HTMLElement>('#slider-one');
    if ($sliderContainerOne) {
        new Swiper($sliderContainerOne, {
            modules: [Autoplay],
            observeParents: true,
            observeSlideChildren: true,
            observer: true,
            watchOverflow: true,
            autoplay: true,
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
        });
    }

    const $sliderContainerTwo = document.querySelector<HTMLElement>('#slider-two');
    if ($sliderContainerTwo) {
        new Swiper($sliderContainerTwo, {
            modules: [Autoplay],
            autoplay: true,
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 16,
            centerInsufficientSlides: true,
        });
    }

    const $sliderContainerThree = document.querySelector<HTMLElement>('#slider-three');
    if ($sliderContainerThree) {
        new Swiper($sliderContainerThree, {
            modules: [Autoplay],
            observeParents: true,
            observeSlideChildren: true,
            observer: true,
            watchOverflow: true,
            autoplay: true,
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 60,
        });
    }
}
